import * as actiontypes from './actionTypes';

export const hideGame = () => {

    return (dispatch) => {
        dispatch({type: actiontypes.HIDE_GAME});

    }
}


export const showGame = () => {

    return (dispatch) => {
        dispatch({type: actiontypes.SHOW_GAME});

    }
}


// WEBPACK FOOTER //
// ./src/actions/gameActions.js